import { render, staticRenderFns } from "./CornersIcon.vue?vue&type=template&id=77aa7822&"
import script from "./CornersIcon.vue?vue&type=script&lang=js&"
export * from "./CornersIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports